export const useCurrency = () => {
    const currencyType = useState<string>('currencyType', () => '')
    const api = useApi()

    const fetchCurrencyConfig = async () => {
        if (currencyType.value) return 

        try {
            const infoRes = await api.get<any>("/user/queryConfig", {}, { server: false, key: `currency-config-${Date.now()}`, retry: 0 });
            const raw = (infoRes as any)?.data || (infoRes as any)?.raw || [];
            const list: Array<{ paramKey?: string; paramValue?: string }> = Array.isArray(raw) ? raw : [];
            const getVal = (k: string) => String(list.find((x) => String(x.paramKey) === k)?.paramValue ?? "");
            currencyType.value = getVal("currency_type");
        } catch (e) {
            console.error("Failed to fetch currency config", e);
        }
    }

    return {
        currencyType,
        fetchCurrencyConfig
    }
}
